module.exports = __webpack_public_path__ + "static/media/buildingConstruction25.da3af571.jpg";